import { __decorate, __metadata } from "tslib";
import { Mutation, VuexModule, Module } from 'vuex-module-decorators';
let PurchaseInquiryModule = class PurchaseInquiryModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.infoRequestDialog = false;
        this.headerDialog = false;
        this.createDialog = false;
        this.tabCond = false;
    }
    get getInfoRequestDialog() {
        return this.infoRequestDialog;
    }
    get getPiHeaderDialog() {
        return this.headerDialog;
    }
    get getCreateDialog() {
        return this.createDialog;
    }
    get getTabCondition() {
        return this.tabCond;
    }
    ['setInfoRequestDialog'](data) {
        this.infoRequestDialog = data;
    }
    ['setPiHeaderDialog'](data) {
        this.headerDialog = data;
    }
    ['setCreateDialog'](data) {
        this.createDialog = data;
    }
    ['setTabCondition'](data) {
        this.tabCond = data;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PurchaseInquiryModule.prototype, 'setInfoRequestDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PurchaseInquiryModule.prototype, 'setPiHeaderDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PurchaseInquiryModule.prototype, 'setCreateDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], PurchaseInquiryModule.prototype, 'setTabCondition', null);
PurchaseInquiryModule = __decorate([
    Module
], PurchaseInquiryModule);
export default PurchaseInquiryModule;
